import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../../types/requestForm';
import { createFields } from '../utils/createFields';
import { createValidation } from '../utils/createValidation';
var FIELDS = [EFormFieldsNames.OwnerComplaintType];
export var OFFER_COMPLAINT_INITIAL_STEP = {
  code: EStepCodes.OfferComplaintInitial,
  question: {
    code: EQuestionCodes.OfferComplaintInitial,
    title: '',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: []
  },
  nextStep: [{
    conditions: [],
    nextStepCode: EStepCodes.OfferComplaintFinal
  }]
};